// https://github.com/nezhar/snypy-frontend

import { Injectable } from "@angular/core";
import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { LoadingScreenService } from "./LoadingScreen.service";
import { finalize } from "rxjs/operators";
import _ from "lodash";
import { TRANSACTIONS_URL } from "@src/constant/common/transaction-detail-url";
import { DASHBOARD_API_ENDPOINT } from "@pages/dashboard/constants";

@Injectable()
export class LoadingScreenInterceptor implements HttpInterceptor {
	activeRequests: number = 0;

	/**
	 * URLs for which the loading screen should not be enabled
	 */
	skippUrls = [
		"/authrefresh",
		"/export/progress",
		...Object.values(TRANSACTIONS_URL),
		...Object.values(DASHBOARD_API_ENDPOINT),
	];

	constructor(private loadingScreenService: LoadingScreenService) {}

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		let displayLoadingScreen = true;

		for (const skippUrl of this.skippUrls) {
			if (new RegExp(skippUrl as string).test(request.url)) {
				displayLoadingScreen = false;
				break;
			}
		}

		if (
			request.params.get("input_search") ||
			request.params.get("skip_loading")
		) {
			displayLoadingScreen = false;
		}

		if (_.get(request, "url", "").indexOf("skip_loading") > -1) {
			displayLoadingScreen = false;
		}

		if (displayLoadingScreen) {
			if (this.activeRequests === 0) {
				this.loadingScreenService.startLoading();
			}
			this.activeRequests++;

			return next.handle(request).pipe(
				finalize(() => {
					this.activeRequests--;
					if (this.activeRequests === 0) {
						this.loadingScreenService.stopLoading();
					}
				})
			);
		} else {
			return next.handle(request);
		}
	}
}
